export function home(bp, $) {
    let w = window.innerWidth;

    const loading = {
        animate() {
            $(".loading__over .loading__logo .loading__logo-ttl").delay(300).animate({
                opacity: 1
            }, 200, 'swing',function() {
            });
            $(".loading__over").delay(2000).animate({
                width: 0
            }, 400, function() {
                $(".loading").delay(500).animate({
                    width: 0
                }, 800, function() {
                    $(".loading").remove();
                });
            });
        }
    };


    const mv = {
        changeHtml(w) {
            const $news = $('#js-mv__news-content');
            if(bp < w) {
                if($('.news__ttl-wrap').length) {
                    $news.find('.news__ttl').unwrap();
                }
            } else {
                if($('.news__ttl-wrap').length == 0) {
                    $news.find('.news__ttl, .news__btn').wrapAll('<div class="news__ttl-wrap"></div>');
                }
            }
        }
    };

    const about = {
        changeHtml(w) {
            const $ele    = $('#js-about__link-wrapper');
            const $targetPC = $('#js-about__heading');
            const $targetSP = $('#js-about__contaner');

            if(bp < w) {
                $($ele).appendTo($targetPC);
            } else {
                $($ele).appendTo($targetSP);
            }
        }
    };

    const news = {
        // もっと見るボタン
        changeHtml01(w) {
            const $ele    = $('#js-news__link-wrapper');
            const $targetPC = $('#js-news__heading');
            const $targetSP = $('#js-news__contaner');

            if(bp < w) {
                $($ele).appendTo($targetPC);
            } else {
                $($ele).appendTo($targetSP);
            }
        },
        // ブログアイテム画像位置
        changeHtml02(w) {
            const $newsItem = $('#js-news__row').find('.news-item');
            $newsItem.each(function() {
                const $ele      = $(this).find('.news-item__img');
                const $targetPC = $(this).find('.news-item__body');
                const $targetSP = $(this).find('.news-item__ttl');

                if(bp < w) {
                    if($(this).find('.news__sp-wrapper').length) {
                        $ele.unwrap();
                    }
                    $($ele).insertBefore($targetPC);
                } else {
                    $($ele).insertBefore($targetSP);
                    if($(this).find('.news__sp-wrapper').length == 0) {
                        $(this).find('.news-item__img, .news-item__ttl').wrapAll('<div class="news__sp-wrapper"></div>');
                    }
                }
            });


        },
        exe() {
            this.changeHtml01(w);
            this.changeHtml02(w);
        }
    };

    const all = function() {
        mv.changeHtml(w);
        about.changeHtml(w);
        news.exe(w);
    };



    all();

    $(window).on('load',function() {
        loading.animate();
    });
    $(window).resize(function() {
        w = window.innerWidth;
        all();
    });
}
